<template lang="html">
  <input class="form-control" type="text" :disabled="props.disabled" :value="props.value" @input="inputValue = $event.target?.value"/>
</template>

<script lang="ts" setup>
import {
  computed, watch, defineProps, defineEmits,
  ref, onMounted, getCurrentInstance,
} from "vue";
import {applyMaskToValue} from "@/components/forms/payout/forms/inputs/input-mask";


const props = defineProps({
  value: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  mask: {
    type: String,
    default: 'DDDD/DD/DD'
  }
})
const emit = defineEmits(['input']);

const formatValue = (value: string) => {
  return applyMaskToValue(value, props.mask);
}

const instance = ref(null);

const inputValue = computed({
  get() {
    return formatValue(props.value);
  },
  set(value) {
    emit('input', formatValue(value), value)
    if (instance.value) {
      instance.value.$forceUpdate();
    }
  }
})

watch(() => props.value, (value) => {
  refreshValue();
})

const refreshValue = () => {
  if (props.value && (props.value.length > 0)) {
    const val = formatValue(props.value);
    if ((val.length > 0) && (val !== props.value)) {
      emit('input', val, props.value);
    }
  }
}

onMounted(() => {
  instance.value = getCurrentInstance().proxy;
  refreshValue();
})
</script>

<style scoped>

</style>
